import imgSchermAfbeelding20240523Om10191 from "../assets/map-safari-popup.webp";
import imgSchermAfbeelding20240523Om10192 from "../assets/itinerary-format-1.webp";
import imgSchermAfbeelding20240523Om10193 from "../assets/train-bridge-aerial.webp";

function CityMap() {
	return (
		<div className="overflow-clip relative rounded-[8px] shrink-0 size-[120px]" data-name="cityMap">
			<div className="absolute h-[125.122px] left-[-16.83px] top-[-1.46px] w-[152.195px]" data-name="Scherm­afbeelding 2024-05-23 om 10.19 1">
				<div aria-hidden="true" className="absolute inset-0 pointer-events-none">
					<img alt="" className="absolute max-w-none object-cover size-full" src={imgSchermAfbeelding20240523Om10191} />
					<img alt="" className="absolute max-w-none object-cover size-full" src={imgSchermAfbeelding20240523Om10192} />
					<img alt="" className="absolute max-w-none object-cover size-full" src={imgSchermAfbeelding20240523Om10193} />
				</div>
			</div>
		</div>
	);
}

export default function Frame() {
	return (
		<div className="content-stretch flex flex-col gap-[5.854px] items-start relative size-full">
			<CityMap />
			<div className="flex flex-col font-['Poppins:Medium',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[#0f3e4a] text-[12px] whitespace-nowrap">
				<p className="leading-[normal]">City</p>
			</div>
		</div>
	);
}
